window.SQL = window.SQL || window.initSqlJs;
